import { ChangeCartTypeResult } from '../../../graphql/cart/changeCartType';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartTypeRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly sourceCustomOrderType: CustomOrderType;
  readonly parentActionId: number;
}

export const apiCartChangeCartTypeRequestedType = 'api/cart/changeCartType--requested';
export const apiCartChangeCartTypeRequested = createAction<ApiCartChangeCartTypeRequestedPayload>(
  apiCartChangeCartTypeRequestedType
);
export type ApiCartChangeCartTypeRequestedAction = ReturnType<
  typeof apiCartChangeCartTypeRequested
>;

export interface ApiCartChangeCartTypeSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartTypeResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartChangeCartTypeSucceededType = 'api/cart/changeCartType--succeeded';
export const apiCartChangeCartTypeSucceeded = createAction<ApiCartChangeCartTypeSucceededPayload>(
  apiCartChangeCartTypeSucceededType
);
export type ApiCartChangeCartTypeSucceededAction = ReturnType<
  typeof apiCartChangeCartTypeSucceeded
>;

export interface ApiCartChangeCartTypeFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartChangeCartTypeFailedType = 'api/cart/changeCartType--failed';
export const apiCartChangeCartTypeFailed = createAction<ApiCartChangeCartTypeFailedPayload>(
  apiCartChangeCartTypeFailedType
);
export type ApiCartChangeCartTypeFailedAction = ReturnType<typeof apiCartChangeCartTypeFailed>;
